import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgBulbOutlined = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="-.5 -.5 16 16"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M1.875 7.5H2.5m5-5.625V2.5m5 5h.625M3.5 3.5l.4375.4375M11.5 3.5l-.4375.4375M5.625 10a3.125 3.125 0 1 1 3.75 0 2.188 2.188 0 0 0-.625 1.875 1.25 1.25 0 0 1-2.5 0A2.188 2.188 0 0 0 5.625 10M6.0625 10.625h2.875" />
  </svg>
);
export default SvgBulbOutlined;
